import { Container, Typography } from "@mui/material"

const Footer =()=>{
    return(
        <Container style={{display:"flex",justifyContent:"center",marginBottom:20}}>
            <Typography>
                Made with ❤️ by Aman
            </Typography>
        </Container>
    );
};

export default Footer;